import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteboardFileSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.96135 3.02143V0.0548571L9.92792 3.02143H6.96135ZM5.45021 3.02143C5.45021 3.42221 5.60942 3.80657 5.89281 4.08997C6.17621 4.37336 6.56057 4.53257 6.96135 4.53257H9.98278V10.4889C9.98278 10.8896 9.82357 11.274 9.54018 11.5574C9.25678 11.8408 8.87242 12 8.47164 12H1.67278C1.4738 12.0001 1.27675 11.9609 1.09297 11.8846C0.909183 11.8084 0.742284 11.6965 0.60186 11.5555C0.461436 11.4145 0.350255 11.2472 0.274707 11.0631C0.199159 10.879 0.160733 10.6818 0.161637 10.4829V1.51714C0.161181 1.11567 0.320053 0.730424 0.603373 0.445978C0.886694 0.161532 1.27131 0.00113513 1.67278 0L5.45021 0V3.02143Z"
          fill="#878A92"
        />
      </svg>
    </span>
  );
};

export default WhiteboardFileSVG;
